import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pause",
  "use": "pause-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"pause\"><path d=\"M23 19.5L23 40.5\" stroke-width=\"4\" /><path d=\"M37 19.5L37 40.5\" stroke-width=\"4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol